import { Component, inject, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductResume } from '../../product/product.types';
import { ProductComponent } from '../../product/product.component';
import { ShopComponent } from '../shop.component';
import { ShopService } from '../shop.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';

@Component({
  selector: 'app-shop-or-product',
  imports: [ProductComponent, ShopComponent],
  templateUrl: './shop-or-product.component.html',
})
export class ShopOrProductComponent {

  #activatedRoute = inject(ActivatedRoute);
  #router = inject(Router);
  #shopService = inject(ShopService);

  #data = null;

  componentTypes = {
    shop: 'shop',
    product: 'product'
  };

  componentType: WritableSignal<string | null> = signal(null);

  #gotoProductDetail$ = toObservable(this.#shopService.gotoProductDetail);

  constructor() {
    this.#getProductsResolverData()
    this.#setUpProductNavigation();
  }

  #getProductsResolverData() {
    this.#activatedRoute.snapshot.data['data'].subscribe((data: any) => {
      this.#data = data;
      this.#validateComponent()
    });
  }

  #validateComponent() {
    const slug = this.#activatedRoute.snapshot.paramMap.get('slug');

    if (!slug) {
      this.#router.navigate(['/shop']);
      return;
    }

    const category = this.#activatedRoute.snapshot.paramMap.get('category');
    const subcategory = this.#activatedRoute.snapshot.paramMap.get('subcategory');

    const url = [category, subcategory, slug].join('/')
    this.componentType.set(this.#getItemType(url));
  }

  #getItemType(slug: string) {
    const d: any = this.#data;
    if (!d) return this.componentTypes.shop;

    const product = d.data.products.find((p: ProductResume) => p.productUrl === slug);

    if (product) return this.componentTypes.product
    return this.componentTypes.shop;
  }

  #setUpProductNavigation() {
    this.#gotoProductDetail$.pipe(
      tap((url: string) => this.componentType.set(this.#getItemType(url)))
    ).subscribe()
  }
}
